export const ChartActionType = {
    FONTFAMILY: 'fontfamily',
    FONT_COLOR: 'font-color',
    FONT_SIZE: 'font-size',
    FONT_SIZE_UP: 'font-size-up',
    FONT_SIZE_DOWN: 'font-size-down',
    BOLD: 'bold',
    ITALIC: 'italic',
};

export type IChartActionType = typeof ChartActionType[keyof typeof ChartActionType];
